import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Select,
    AspectRatio,
    Tooltip, TooltipTrigger, TooltipContent, TooltipProvider,
    Avatar,
    Tabs,
    Badge,
    Popover, PopoverTrigger, PopoverContent
} from "../../ui/ot";
import {
    Card,
    CardContent,
    CardDescription,
} from "../../ui/card"
import { Pencil, Folder, File, Trash } from "lucide-react";
import DocumentManagementModal from './document_management_modal'
import { useDocument } from '../controllers/document_controller'
import { useFileUpload } from "../controllers/FileUploadController";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useFileType } from '../controllers/file_type_controller'
import { useHashTag } from "../controllers/HashTagController";
import Upload_modal from "../Upload_ot_modal"
import dayjs from 'dayjs'
import styled from "styled-components";
import axios from "axios";
const DocumentManagement = ({
    mode = "browser"
}) => {
    return <Row>
        <Col span={24}>
            <Row>
                <Col>
                    <Typography.Title level={2}>
                        檔案儲存管理
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            {mode === "browser" && <>
                <DocumentManagementTable
                    // propsClassifyStructureTypeId ={'0'}
                    onSelectChange={(val) => {
                        console.log(val)
                    }}
                />
            </>}
            {mode === "gallery" && <>
                <Gallery />
            </>}
        </Col>
    </Row>
}

const DocumentManagementTable = ({
    defaultSelectKeys = [],
    onSelectChange = () => { },
    propsClassifyStructureTypeId, //呈現資料的資料夾
}) => {
    const navigate = useNavigate();
    const actionRef = useRef(null);
    const fileDataRef = useRef([])
    const [searchParams] = useSearchParams()
    const { classify_structure_type_id } = Object.fromEntries([...searchParams])
    const [showClassifyStructureTypeId, setShowClassifyStructureTypeId] = useState(propsClassifyStructureTypeId ? propsClassifyStructureTypeId : classify_structure_type_id)
    const modalRef = useRef(null);
    const columns = [
        {
            title: "類型",
            dataIndex: "file_client_name",
            key: "file_client_name",
            disabled: true,
            render: (text, record, _index) => {
                if (record?.classify_structure_id === 1) {
                    return <Avatar
                        icon={<Folder
                            style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                color: record?.font_color,
                                backgroundColor: record?.background_color
                            }}
                        />}
                        size="small"

                    >
                    </Avatar>
                }
                else if (record?.classify_structure_id === 36) {
                    return <Avatar
                        icon={<File
                            style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                color: record?.font_color
                            }}
                        />}
                        size="small"
                        src={!!getDocumentFileTypeImage(record?.file_client_name, fileDataRef.current)?.file_url ? getDocumentFileTypeImage(record?.file_client_name, fileDataRef.current)?.file_url : false}>
                    </Avatar>
                }
            }
        },
        {
            title: "名稱",
            dataIndex: "file_client_name",
            key: "file_client_name",
            render: (text, record, _index) => {
                if (record?.classify_structure_id === 36) {
                    return record?.file_client_name
                }
                else {
                    return record?.title
                }
            }
        },
        {
            title: "標籤",
            dataIndex: "hashtag_data",
            key: "hashtag_data",
            render: (text, record, _index) => {
                return <Row gutter={[4, 4]}>
                    {
                        record?.hashtag_data?.map((hashtag) => {
                            return <Col>
                                <Badge>
                                    {hashtag?.hashtag_name}
                                </Badge> </Col>
                        })
                    }
                </Row>
            }
        },
        {
            title: "分類",
            dataIndex: "category_data",
            key: "category_data",
            render: (text, record, _index) => {
                return <Row gutter={[4, 4]}>
                    {
                        record?.category_data?.map((category) => {
                            return <Col>
                                <Badge>
                                    {category?.category_name}
                                </Badge> </Col>
                        })
                    }
                </Row>
            }
        },
        {
            title: "建立人",
            key: "upload_user_name",
            dataIndex: "upload_user_name",
            render: (text, record, _index) => {
                return <>{record?.upload_user_name}</>
            }
        },
        {
            title: "最後編輯人",
            key: "last_edit_user_name",
            dataIndex: "last_edit_user_name",
            render: (text, record, _index) => {
                return <>{record?.last_edit_user_name}</>
            }
        },
        {
            title: "最後編輯時間",
            dataIndex: "last_edit_time",
            key: "last_edit_time",
            render: (text, record, _index) => {
                return <>{dayjs(record?.last_edit_time).format("YYYY-MM-DD HH:mm:ss")}</>
            }
        },
        {
            title: "操作",
            key: "option",
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Row wrap={false} gutter={[8, 8]}>
                        <Col>
                            <Button
                                onClick={() => {
                                    handleEditRow(record)
                                }}
                            >
                                編輯
                            </Button>
                        </Col>
                        <Col>
                            <DeletePopHover
                                onConfirm={() => {
                                    handleDeleteRow(record)
                                }}
                                onCancel={() => { }}
                            />
                        </Col>
                        <Col>
                            <Button
                                disabled={true}
                                onClick={() => {
                                    // handleEditRow(record)
                                }}
                            >
                                檢查權限
                            </Button>
                        </Col>
                    </Row>
                );
            },
        },
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectKeys ? defaultSelectKeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const [topic, setTopic] = useState("card");
    const [tableSearchParams, setTableSearchParams] = useState({
        file_type_id_arr: [],
        hashtag_id_arr: []
    })
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.classify_structure_type_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.classify_structure_type_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            onSelectChange({
                selectedRowKeys: select_temp,
                selectedRowsInfo: selectRow
            })
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.classify_structure_type_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.classify_structure_type_id
                );
                selectRow = selectRow.filter(
                    (row) => row.classify_structure_type_id !== record.classify_structure_type_id
                );
            }
            onSelectChange({
                selectedRowKeys: select_temp,
                selectedRowsInfo: selectRow
            })
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [editClassifyStructureId, setEditClassifyStructureId] = useState(null)
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        setEditClassifyStructureId(record?.classify_structure_id)
        form.resetFields();
        let file_type_id = record?.file_type_id
        let hashtag_id_arr = (record?.hashtag_data || []).map((hashtag) => {
            return hashtag?.hashtag_id
        })
        let category_id_arr = (record?.category_data || []).map((category) => {
            return category?.category_id
        })
        let editRecord = {
            ...record,
            file_type_id,
            hashtag_id_arr,
            category_id_arr
        }

        form.setFieldsValue(editRecord)

    };
    const handleDeleteRow = (record) => {
        if (parseInt(record?.classify_structure_id) === 36) {
            // deleteClassifyStructureTypeFolderData([
            //     {
            //         classify_structure_type_id:record?.classify_structure_type_id
            //     }
            // ])
            patchDeleteClassifyStructureTypeFileData([{ file_id: record?.file_id }])
        }
        else if (parseInt(record?.classify_structure_id) === 1) {
            deleteClassifyStructureTypeFolderData([
                {
                    classify_structure_type_id: record?.classify_structure_type_id
                }
            ])
        }
        // let data = [];
        // if (id) {
        //     data = [
        //         {
        //             classify_structure_type_id: id,
        //         },
        //     ];
        // } else {
        //     data = selectedRowsInfo.map((val) => {
        //         return {
        //             classify_structure_type_id: val?.classify_structure_type_id,
        //         };
        //     });
        // }
        // if (data.length > 0) {
        //     // deleteClassifyStructureTypeFileData()
        //     // deleteClassifyStructureTypeFolderData()
        //     deleteDocumentData(data);
        // } else {
        //     message.info("請選擇項目");
        // }
    };

    const onFormFinish = (value) => {
        let editValue = { ...value }

        editValue["hashtag_data"] = (editValue?.hashtag_id_arr || []).map((hashtag) => {
            return {
                hashtag_id: hashtag
            }
        })
        editValue["category_data"] = (editValue?.category_id_arr || []).map((category) => {
            return {
                category_id: category
            }
        })
        if (axiosMode === "post") {
            if (editClassifyStructureId === 36) {
            }
            else if (editClassifyStructureId === 1) {

            }
            // postDocumentData([value]);
        } else if (axiosMode === "patch") {
            if (editClassifyStructureId === 36) {
                patchClassifyStructureTypeFileData([editValue])
            }
            else if (editClassifyStructureId === 1) {
                patchClassifyStructureTypeFolderData([{
                    ...editValue,
                    name: editValue?.title
                }])
            }
            // patchDocumentData([value]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    };
    const changeFolder = (new_classify_structure_type_id) => {
        if (propsClassifyStructureTypeId) {
            setShowClassifyStructureTypeId(new_classify_structure_type_id)
        }
        else {
            let route = `/media_classification_storage/documentManagement?` + (new URLSearchParams({ classify_structure_type_id: new_classify_structure_type_id }).toString());
            navigate(route)
            setShowClassifyStructureTypeId(new_classify_structure_type_id)
        }
    }
    const {
        getDocumentData,
        deleteDocumentData,
        patchClassifyStructureTypeFolderData,
        patchClassifyStructureTypeFileData,
        patchDeleteClassifyStructureTypeFileData,
        deleteClassifyStructureTypeFolderData,
        deleteClassifyStructureTypeFileData
    } = useDocument({
        onFinish,
        onBefore,
    });
    const {
        getFileTypeData,
        FileTypeData,
        getDocumentFileTypeImage,

    } = useFileType({

    })

    const {
        getHashTagData,
        HashTagData
    } = useHashTag({

    })
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
        getFileTypeData({})

        getHashTagData({})
    }, []);
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [showClassifyStructureTypeId])
    useEffect(() => {
        fileDataRef.current = FileTypeData
    }, [FileTypeData])
    return (<Row>
        <Col span={24}>
            <Row>

                <Col>
                    <DocumentManagementModal
                        openButtonText={editClassifyStructureId === 36 ? "檔案" : "資料夾"}
                        axiosMode={axiosMode}
                        propsOpen={modalOpen}
                        propsSetOpen={setModalOpen}
                        propsForm={form}
                        propsLoading={modalLoading}
                        propsSetLoading={setModalLoading}
                        onFinish={onFormFinish}
                    />
                </Col>


                <Col span={24}>
                    <Row justify={"end"} gutter={[8, 8]}>
                        {/* <Col>
                            <Button >
                                多選下載
                            </Button>
                        </Col>
                        <Col>
                            <Button >
                                上傳檔案
                            </Button>
                        </Col> */}
                    </Row>
                </Col>
                <Col span={24}>
                    <ProTableOt
                        expandable={true}
                        showMode={topic}
                        rowKey={"classify_structure_type_id"}
                        actionRef={actionRef}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<Row gutter={[8, 8]}>
                            <Col>
                                <Tabs
                                    activeKey={topic}
                                    items={[
                                        {
                                            key: "card",
                                            tab: "圖像"
                                        },
                                        {
                                            key: "infiniteScroll",
                                            tab: "列表"
                                        }
                                    ]}
                                    onChange={(val) => {
                                        setTopic(val)
                                    }}
                                />
                            </Col>
                            <Col>
                                <Select
                                    value={tableSearchParams?.file_type_id_arr}
                                    mode={"multiple"}
                                    placeholder="類型"
                                    options={FileTypeData.map((fileType) => {
                                        return {
                                            label: fileType?.name,
                                            value: fileType?.file_type_id
                                        }
                                    })}
                                    onChange={(value) => {
                                        setTableSearchParams((pre) => {
                                            return {
                                                ...pre,
                                                file_type_id_arr: value
                                            }
                                        })
                                    }}
                                />
                            </Col>
                            {/* <Col>
                                <Select
                                    placeholder="標籤"
                                    value={tableSearchParams?.hashtag_id_arr}
                                    mode={"multiple"}
                                    options={HashTagData.map((hashTag) => {
                                        return {
                                            label: hashTag?.tag_name,
                                            value: hashTag?.tag_id
                                        }
                                    })}
                                    onChange={(value) => {
                                        setTableSearchParams((pre) => {
                                            return {
                                                ...pre,
                                                hashtag_id_arr: value
                                            }
                                        })
                                    }}
                                />
                            </Col> */}
                            {/* <Col>
                                <AdvancedSearchModal />
                            </Col> */}
                            {/* <Col>
                                <Button >
                                    多選下載
                                </Button>
                            </Col> */}

                            <Col>
                                <Upload_modal
                                    classify_structure_type_id={showClassifyStructureTypeId}
                                    reload={() => {
                                        actionRef.current.reloadAndRest()
                                    }}
                                />
                            </Col>
                            {/* <Col>
                                <Button >
                                    多選刪除
                                </Button>
                            </Col> */}
                        </Row>}
                        request={async (params = {}, sort, filter) => {
                            // setAxiosMethod("get")
                            let newParams = {};
                            let order = setOrders(sort);
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key,
                                file_type_id_arr: tableSearchParams?.file_type_id_arr.length > 0 ? JSON.stringify(tableSearchParams?.file_type_id_arr) : null,
                                hashtag_id_arr: tableSearchParams?.hashtag_id_arr.length > 0 ? JSON.stringify(tableSearchParams?.hashtag_id_arr) : null
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });

                            return getDocumentData({
                                classify_structure_type_id: showClassifyStructureTypeId,
                                classify_structure_id: JSON.stringify([1, 36]),
                                ...tableSearchParams,
                                ...newParams,
                            });
                        }}
                        toolBarRender={() => {
                            return [

                            ];
                        }}
                        rowSelection={{
                            type: "checkbox",
                            selectedRowKeys: selectedRowKeys,
                            ...rowSelection,
                        }}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={true}
                        cardModeSetting={
                            {

                                columnsCount: 5,
                                singleRowHeight: "",
                            }
                        }
                        pageSize={15}
                        cardRender={(record) => {
                            return <MediaCard
                                fileTypeData={FileTypeData}
                                handleEditRow={handleEditRow}
                                handleDeleteRow={handleDeleteRow}
                                record={record}
                                changeFolder={changeFolder}
                            />
                        }}
                        searchParams={
                            {
                                classify_structure_type_id: showClassifyStructureTypeId
                            }
                        }
                    />
                </Col>
            </Row>
        </Col>
    </Row>)
}
const MediaCard = ({
    fileTypeData = [],
    mode = "edit",
    record,
    changeFolder = () => { },
    handleEditRow = () => { },
    handleDeleteRow = () => { }
}) => {
    const navigate = useNavigate();
    const [mediaData, setMediaData] = useState(record)
    const {
    } = useDocument({
        onFinish: () => { },
        onBefore: () => { },
    });
    const {
        getFileUploadData
    } = useFileUpload({
        onBefore: () => { },
        onFinish: () => { },
    });
    const {
        FileTypeData,
        getFileTypeData,
        getDocumentFileTypeImage
    } = useFileType({

    })

    useEffect(() => {
        if (mediaData?.cover_image_file_id && !mediaData?.cover_image_file_url) {
            getFileUploadData({
                file_id: mediaData?.cover_image_file_id
            })
                .then((response) => {
                    setMediaData((pre) => {
                        return {
                            ...pre,
                            cover_image_file_url: response?.dataurl
                        }
                    })
                })
        }
    }, [mediaData?.cover_image_file_id])
    useEffect(() => {
        if (!fileTypeData) {
            getFileTypeData({})
        }
    }, [])

    return (<Row>
        <Col span={24}>
            {
                mediaData?.classify_structure_id === 1 &&
                (

                    <Card
                        onDoubleClick={() => {
                            changeFolder(mediaData?.classify_structure_type_id)
                        }}
                        style={{
                            height: "100%",
                            color: mediaData?.font_color,
                            fontColor: mediaData?.font_color,
                            backgroundColor: mediaData?.background_color
                        }}
                    >
                        <Row gutter={[8, 4]}>
                            <Col span={24}>
                                <AspectRatio ratio={16 / 9}>
                                    <Folder
                                        style={{
                                            objectFit: 'cover',
                                            width: '100%',
                                            height: '100%',
                                            color: mediaData?.font_color
                                        }}
                                    />
                                </AspectRatio >
                            </Col>
                            <Col span={24}>
                                <CardContent>
                                    <Row>
                                        <Col span={24}>
                                            <Row gutter={[16, 16]} justify="space-between" align="middle">
                                                <Col >
                                                    <Avatar
                                                        size="small"
                                                        icon={<Folder />}
                                                    />
                                                </Col>
                                                <Col>
                                                    <TooltipProvider>
                                                        <Tooltip>
                                                            <TooltipTrigger>
                                                                <Button
                                                                    hidden={mode !== "edit"}
                                                                    onClick={() => {
                                                                        handleEditRow(record)
                                                                    }}
                                                                    variant="ghost"
                                                                    size="icon">
                                                                    <Pencil className="h-4 w-4" />
                                                                </Button>
                                                            </TooltipTrigger>
                                                            <TooltipContent>
                                                                <p>編輯資料夾</p>
                                                            </TooltipContent>
                                                        </Tooltip>
                                                    </TooltipProvider>

                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <TooltipProvider>
                                                <Tooltip>
                                                    <TooltipTrigger
                                                        style={
                                                            {
                                                                justify: "start",
                                                                width: "100%"
                                                            }
                                                        }
                                                    >
                                                        <Typography.P
                                                            style={{
                                                                width: "100%",
                                                                fontWeight: "700",
                                                                whiteSpace: 'nowrap', /* 禁止換行 */
                                                                overflow: 'hidden',/* 隱藏超出的內容 */
                                                                textOverflow: 'ellipsis', /* 使用省略號來截斷文字 */
                                                            }}>{mediaData?.name || mediaData?.title}</Typography.P>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        <p>{mediaData?.title}</p>
                                                    </TooltipContent>
                                                </Tooltip>
                                            </TooltipProvider>
                                        </Col>
                                        <Col span={24}>
                                            <Typography.P>建立人:{mediaData?.upload_user_name}</Typography.P>
                                        </Col>
                                        <Col span={24}>
                                            <CardDescription>編輯時間:{dayjs(mediaData?.last_edit_time).format("YYYY-MM-DD")}</CardDescription>
                                        </Col>
                                        <Col span={24}>
                                            <Row gutter={[4, 4]}>
                                                {(mediaData?.hashtag_data || [])?.map((hashtag) => {
                                                    return <Col> <Badge>
                                                        {hashtag?.hashtag_name}
                                                    </Badge> </Col>
                                                })}
                                            </Row>

                                        </Col>
                                        <Col span={24}>
                                            <Row gutter={[4, 4]}>
                                                {(mediaData?.category_data || [])?.map((category) => {
                                                    return <Col>
                                                        <Badge variant="secondary">
                                                            {category?.category_name}
                                                        </Badge>
                                                    </Col>
                                                })}
                                            </Row>
                                        </Col>
                                        {mode === "edit" && <Col span={24}  >

                                            <Row justify="end" >
                                                <Col

                                                >
                                                    <DeletePopHover
                                                        onConfirm={() => {
                                                            handleDeleteRow(record)
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>}
                                    </Row>
                                </CardContent>
                            </Col>
                        </Row>
                    </Card >
                )
            }
            {
                mediaData?.classify_structure_id === 36 &&
                (
                    <Card
                        style={{
                            height: "100%"
                        }}
                    >
                        <Row gutter={[8, 4]}>
                            <Col span={24}>
                                <AspectRatio ratio={16 / 9}>
                                    <img
                                        className="rounded-t"
                                        src={mediaData?.cover_image_file_url || getDocumentFileTypeImage(mediaData?.file_client_name, fileTypeData)?.file_url}
                                        alt=""
                                        style={{
                                            objectFit: 'cover',
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: ""
                                        }}
                                    />
                                </AspectRatio >
                            </Col>
                            <Col span={24}>
                                <CardContent>
                                    <Row>
                                        <Col span={24}>
                                            <Row gutter={[16, 16]} justify="space-between" align="middle">
                                                <Col >
                                                    <Avatar
                                                        src={!!getDocumentFileTypeImage(mediaData?.file_client_name, fileTypeData)?.file_url ? getDocumentFileTypeImage(mediaData?.file_client_name, fileTypeData)?.file_url : false}
                                                        size="small"
                                                        icon={<File
                                                            style={{
                                                                objectFit: 'cover',
                                                                width: '100%',
                                                                height: '100%',
                                                                color: record?.font_color
                                                            }}
                                                        />}
                                                    >

                                                    </Avatar>
                                                </Col>
                                                <Col>
                                                    <TooltipProvider>
                                                        <Tooltip>
                                                            <TooltipTrigger>
                                                                <Button
                                                                    hidden={mode !== "edit"}
                                                                    onClick={() => {
                                                                        handleEditRow(record)
                                                                    }}
                                                                    variant="ghost"
                                                                    size="icon">
                                                                    <Pencil className="h-4 w-4" />
                                                                </Button>
                                                            </TooltipTrigger>
                                                            <TooltipContent>
                                                                <p>編輯檔案</p>
                                                            </TooltipContent>
                                                        </Tooltip>
                                                    </TooltipProvider>

                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <TooltipProvider>
                                                <Tooltip>
                                                    <TooltipTrigger
                                                        style={
                                                            {
                                                                justify: "start",
                                                                width: "100%"
                                                            }
                                                        }
                                                    >
                                                        <Typography.P
                                                            style={{
                                                                width: "100%",
                                                                fontWeight: "700",
                                                                whiteSpace: 'nowrap', /* 禁止換行 */
                                                                overflow: 'hidden',/* 隱藏超出的內容 */
                                                                textOverflow: 'ellipsis', /* 使用省略號來截斷文字 */
                                                            }}>{mediaData?.file_client_name}</Typography.P>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        <p>{mediaData?.file_client_name}</p>
                                                    </TooltipContent>
                                                </Tooltip>
                                            </TooltipProvider>
                                        </Col>
                                        <Col span={24}>
                                            <Typography.P>建立人:{mediaData?.upload_user_name}</Typography.P>
                                        </Col>
                                        <Col span={24}>
                                            <CardDescription>編輯時間:{dayjs(mediaData?.last_edit_time).format("YYYY-MM-DD")}</CardDescription>
                                        </Col>
                                        <Col span={24}>
                                            <Row gutter={[4, 4]}>
                                                {(mediaData?.hashtag_data || [])?.map((hashtag) => {
                                                    return <Col> <Badge>
                                                        {hashtag?.hashtag_name}
                                                    </Badge> </Col>
                                                })}
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <Row gutter={[4, 4]}>
                                                {(mediaData?.category_data || [])?.map((category) => {
                                                    return <Col>
                                                        <Badge variant="secondary">
                                                            {category?.category_name}
                                                        </Badge>
                                                    </Col>
                                                })}
                                            </Row>

                                        </Col>
                                        {mode === "edit" && <Col span={24}>
                                            <Row justify="end">
                                                <Col>
                                                    <DeletePopHover
                                                        onConfirm={() => {
                                                            handleDeleteRow(record)
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </Col>
                                            </Row>

                                        </Col>}
                                    </Row>

                                </CardContent>
                            </Col>
                        </Row>
                    </Card >
                )
            }

        </Col >
    </Row >)
}
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce(
        (all, [key, value]) =>
            value === "" ? { ...all } : { ...all, [key]: value },
        {}
    );
};
const DeleteButtonPopHover = ({ onConfirm = () => { }, onCancel = () => { } }) => {
    const [deleteOpen, setDeleteOpen] = useState(false);

    return (
        <Popover open={deleteOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                        setDeleteOpen(true);
                    }}
                >
                    <Trash />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-60">
                <Row>
                    <Col span={24}>確定要刪除嗎？</Col>
                    <Col span={24}>
                        <Row justify={"space-around"}>
                            <Col>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                        setDeleteOpen(false);
                                        onCancel();
                                    }}
                                >
                                    取消
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    size="sm"
                                    onClick={() => {
                                        onConfirm();
                                    }}
                                >
                                    確定
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </PopoverContent>
        </Popover>
    );
};
export default DocumentManagement
export { MediaCard, DocumentManagementTable }


const GalleryItem = ({ imageUrl, wrap = false }) => {
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const response = await axios.get(imageUrl, {
                    responseType: 'blob',
                });
                const imageBlobUrl = URL.createObjectURL(response.data);
                setImageSrc(imageBlobUrl);
            } catch (error) {
                console.error('Error fetching the image:', error);
            }
        };

        fetchImage();
    }, [imageUrl]);

    return (
        <GalleryItemContainer>
            {imageSrc ? <img src={imageSrc} alt="Gallery Item" style={{ ...(wrap ? {} : { width: '200px', height: '150px' }) }} /> : <p>Loading...</p>}
        </GalleryItemContainer>
    );
};

const Gallery = ({

}) => {
    const [searchParams] = useSearchParams()
    const { classify_structure_type_id } = Object.fromEntries([...searchParams])
    return <>
        <GalleryMain
            propsClassifyStructureTypeId={classify_structure_type_id}
        />
    </>
}
const GalleryMain = ({
    defaultSelectKeys = [],
    onSelectChange = () => { },
    propsClassifyStructureTypeId, //呈現資料的資料夾
    wrap = false,
    firstData = false
}) => {
    const [showClassifyStructureTypeId, setShowClassifyStructureTypeId] = useState(propsClassifyStructureTypeId)
    const images = [
        'https://via.placeholder.com/300x200',
        'https://via.placeholder.com/300x200',
        'https://via.placeholder.com/300x200',
        'https://via.placeholder.com/300x200',
        'https://via.placeholder.com/300x200',
    ];

    const {
        DocumentData,
        getDocumentData,
    } = useDocument({
        onFinish: () => { },
        onBefore: () => { },
    });

    useEffect(() => {
        getDocumentData({
            classify_structure_type_id: showClassifyStructureTypeId,
            classify_structure_id: JSON.stringify([36]),
        });
    }, [])
    return (<>
        {firstData && <>
            <GalleryContainer wrap={wrap}>
                {[DocumentData.find(_ => true)]?.map((document, index) => (<>
                    <GalleryItem key={index} wrap={wrap} imageUrl={'/media_classification_storage/api/file/upload?file_id=' + document?.classify_structure_type_file_data?.find(_ => true)?.file_id} />
                </>))}
            </GalleryContainer>
        </>}
        {!firstData && <>
            共{DocumentData.length}張照片
            <GalleryContainer wrap={wrap}>
                {DocumentData.map((document, index) => (<>
                    {(index + 1)}.
                    <GalleryItem key={index} wrap={wrap} imageUrl={'/media_classification_storage/api/file/upload?file_id=' + document?.classify_structure_type_file_data?.find(_ => true)?.file_id} />
                </>))}
            </GalleryContainer>
        </>}
    </>);
};
const GalleryContainer = styled.div`
  display: flex;
  ${props => props?.wrap === false ? 'flex-direction: row; overflow-x: auto; white-space: nowrap;' : 'flex-direction: column; overflow-y: auto;'}
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const GalleryItemContainer = styled.div`
  flex: 0 0 auto;
  margin-right: 16px;
`;

export { GalleryMain }